module.exports = __webpack_public_path__ + "assets/media/forgetpassword_sent.da6cd5a3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/forgetpassword_sent.svg
// module id = 298
// module chunks = 0